import PageHeader from "@/components/site/PageHeader";
import PageTitle from "@/components/site/PageTitle";
import ServicesSection from "@/components/site/ServicesSection";
import CTASection from "@/components/site/CTASection";

export default function ServicesPage() {
  return (
    <main data-testid="services-page">
      <PageTitle title="Services" />
      <PageHeader
        eyebrow="Services"
        code="03"
        kicker="Delivery model"
        title={
          <>
            From workshop to{" "}
            <span className="italic font-display-soft">whole-school</span>{" "}
            transformation.
          </>
        }
        lead="Choose what fits — a single workshop, a full lab, or a year-long institutional program. We deliver the same quality across every scope."
      />
      <ServicesSection withHeading={false} />
      <CTASection />
    </main>
  );
}
